import { createBaseQueryWithReauth } from '@foundation-bb/foundation-auth';
import { env } from '@/env';
import { refreshToken, logoutUser, selectAccessToken } from '@/store/authSlice';

/**
 * Canonical Foundation reauth base query: sends the access token + cookies, retries
 * transient 5xx, and on 401 performs a single refresh then retries once; a still-failing
 * 401 dispatches logout. Replaces Scribia's bespoke `baseQueryWithReauth` + `retry`
 * wrapper (which it folds in via `transientRetries`).
 */
export const baseQueryWithRetry = createBaseQueryWithReauth({
  baseUrl: env.api.baseUrl,
  selectToken: (state) => selectAccessToken(state as Parameters<typeof selectAccessToken>[0]),
  refreshAction: () => refreshToken(),
  logoutAction: () => logoutUser(),
  transientRetries: 3,
});
